import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import type { GetSigninDataResponse } from "@ServerTypes/accounts/accounts.schema";

/**
 * Redux state for signinData. Populated via `setSigninData({ data: <GetSigninDataResponse> })`
 * (see Router.tsx); `null` until the first dispatch. Consumers read `signinData.data.frontendUrl`
 * and `signinData.data.EnableMultiPortal`, both of which live on `GetSigninDataResponse`.
 */
export type SigninDataState = { data?: GetSigninDataResponse } | null;

const initialState = null as SigninDataState;

const signinDataSlice = createSlice({
  name: "signinData",
  initialState,
  reducers: {
    setSigninData: (_state: SigninDataState, action: PayloadAction<SigninDataState>) => action.payload,
  },
});

export const { setSigninData } = signinDataSlice.actions;
export default signinDataSlice.reducer;
